import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Paper,
    Tabs,
    Tab,
} from '@material-ui/core';
import { TabContext, TabPanel } from '@material-ui/lab';
import BaseInfoSummary from './BaseInfoSummary';
import EmployeeSelectionSummary from './EmployeeSelectionSummary';
import SchedulePeriodSummary from './SchedulePeriodSummary';
import ScheduleSelectionSummary from './ScheduleSelectionSummary';
import EmployeeListSummary from './EmployeeListSummary';
import ShiftlineTable from '../ScheduleSelection/ShiftlineTable';
import './BidSummary.scss';

const tabsOptions = Object.freeze({
    EmployeeList: 0,
    Schedules: 1,
});

function BidSummary() {
    const { t } = useTranslation('shiftBidding');
    const [selectedTab, setSelectedTab] = useState(tabsOptions.EmployeeList);

    return (
        <div className="summary-profile-edit-container">
            <Paper
                className="bid-edit-summary-sections"
                square
            >
                <BaseInfoSummary />
                <ScheduleSelectionSummary />
                <EmployeeSelectionSummary />
                <SchedulePeriodSummary />
            </Paper>
            <Paper
                className="summary-right-panel"
                square
            >
                <TabContext value={selectedTab.toString()}>
                    <Paper square>
                        <div className="summary-tabs-header">
                            <Tabs
                                value={selectedTab}
                                onChange={(event, value) => setSelectedTab(value)}
                                indicatorColor="primary"
                                textColor="primary"
                                aria-label="Summary tabs"
                            >
                                <Tab
                                    label={t('form.summaryTabs.employees')}
                                />
                                <Tab
                                    label={t('form.summaryTabs.schedules')}
                                />
                            </Tabs>
                        </div>
                    </Paper>
                    <Paper
                        square
                        className="summary-tabs-content"
                    >
                        <TabPanel value={tabsOptions.EmployeeList.toString()}>
                            <EmployeeListSummary />
                        </TabPanel>

                        <TabPanel value={tabsOptions.Schedules.toString()}>
                            <>
                                <div id="employeeSummarySectionHeader" />
                                <ShiftlineTable
                                    isSummary
                                    isDisabled
                                />
                            </>
                        </TabPanel>
                    </Paper>
                </TabContext>
            </Paper>
        </div>
    );
}

export default BidSummary;
